import { gql, TypedDocumentNode } from '@apollo/client';
import { AccountDesignerPreferencesVertical } from '../../useDesigners';

export type FollowDesignerMutation = {
  __typename: 'FollowDesignerPayload';
};

export type FollowDesignerMutationVariables = {
  input: {
    user_id: number;
    designer_id: number;
    vertical: AccountDesignerPreferencesVertical;
    inference_type: 'explicit';
    action: 'follow';
  };
};

export const FOLLOW_DESIGNER_MUTATION: TypedDocumentNode<
  FollowDesignerMutation,
  FollowDesignerMutationVariables
> = gql`
  mutation FollowDesignerMutation($input: FollowDesignerMutationVariables!) {
    followDesigner(input: $input)
      @rest(
        type: "FollowDesignerPayload"
        endpoint: "preferences"
        method: "POST"
        path: "/v1/preferences"
      ) {
      NoResponse
    }
  }
`;
